export const USER_TYPES = Object.freeze({
  LICENSE_USER: 'LICENSE_USER',
  SUPPORT_USER: 'SUPPORT_USER',
  FREE_USER: 'FREE_USER',
});

export const USER_PERMISSIONS = Object.freeze({
  EDIT_ALL: 'EDIT_ALL',
});
